import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';
import { Api } from '../../api';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { LibraryFormSubmission } from '../../models/LibraryFormSubmission';

interface ILibrarySubmissionDetailProps {
  submissionId: number;
}

export function LibrarySubmissionDetail(props: ILibrarySubmissionDetailProps): JSX.Element {
  const { submissionId } = props;
  const [submission, setSubmission] = useState<LibraryFormSubmission|undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!submissionId) {
      NotificationHelper.toastError('Ophalen antwoorden mislukt, doordat het ID mist.');
      return;
    }
    Api.getLibraryFormSubmission(submissionId)
      .then(submission => setSubmission(submission))
      .catch(err => {
        console.error('Getting submission failed', err);
        NotificationHelper.toastError('Ophalen antwoorden mislukt, probeer het later opnieuw.');
      })
      .finally(() => setLoading(false));
  }, [submissionId]);

  const getInnerHtml = (submission: LibraryFormSubmission) => (
    submission.html
      .replaceAll('\n', '</br>')
      .replace('style=\'width: 600px\'', '')
  );

  return (
    <>
      {!loading && submission &&
      <div className="form-submission-detail">
        <div className="form-submission-detail__html" dangerouslySetInnerHTML={{ __html: getInnerHtml(submission) }} />
      </div>
      }
      { loading && <Spinner animation="border" variant="primary" /> }
    </>
  );
}
